import {
  isInstructionHandbookHeaderOnlySection,
  type InstructionHandbookSectionRecord,
} from '@artem-lex/compliance-documents'

export function shouldShowInstructionHandbookSectionEditor(
  section: InstructionHandbookSectionRecord
): boolean {
  return !isInstructionHandbookHeaderOnlySection(section.sectionId)
}
